import { render, staticRenderFns } from "./schoolData.vue?vue&type=template&id=4e5162d6&scoped=true&"
import script from "./schoolData.vue?vue&type=script&lang=js&"
export * from "./schoolData.vue?vue&type=script&lang=js&"
import style0 from "./schoolData.vue?vue&type=style&index=0&id=4e5162d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5162d6",
  null
  
)

export default component.exports